const getVendorInvoices = state => {
  return state.vendorInvoices;
};

export default {
  getVendorInvoices,
};
